import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { HatLoading } from "../../components/loading-screen";
import { useFullCurrentUser } from "../../hooks/useCurrentUser";

import { useSchoolLevels } from "../../hooks/useSchoolLevels";

const ProtectedRoute = observer(
  ({ children, requiredRole = [], requiredLevel = [] }) => {
    const { activeUserRecord, userRecordsLoading } = useFullCurrentUser();
    const { matchesSchoolLevels, isLoadingSchoolLevels, schoolLevels } =
      useSchoolLevels();

    const location = useLocation();

    if (userRecordsLoading || isLoadingSchoolLevels) {
      return <HatLoading />;
    }

    if (!activeUserRecord || !activeUserRecord.userID) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    // Super admins with an active district should be treated as district admins for route access
    const effectiveRole =
      activeUserRecord.role === "superadmin" &&
      activeUserRecord.activeDistrictId
        ? "districtadmin"
        : activeUserRecord.role;

    // Check both actual role and effective role (so superadmins can still access superadmin routes)
    if (
      requiredRole.length > 0 &&
      !requiredRole.includes(effectiveRole) &&
      !requiredRole.includes(activeUserRecord.role)
    ) {
      console.log(
        "🔒 Does not have required role: ",
        requiredRole,
        effectiveRole,
      );
      return <Navigate to="/404" replace />;
    }
    if (requiredLevel.length > 0 && !matchesSchoolLevels(requiredLevel)) {
      console.log(
        "🔒 Does not have required school level: ",
        requiredLevel,
        schoolLevels,
      );
      return <Navigate to="/404" replace />;
    }

    return children;
  },
);

export default ProtectedRoute;
